function getMaxAmountLeft(
  maxAmount: number | undefined,
  amountLeft: number | undefined,
): number | undefined {
  return maxAmount && amountLeft !== undefined
    ? Math.min(maxAmount, amountLeft) : maxAmount;
}

export default getMaxAmountLeft;
